import { ReactElement } from 'react';
import FormGroup from '~/components/form/FormGroup';
import { BreOrderContext } from '~/tenants/bre/model/BreOrderContext';
import { BreFloorplanRate } from '~/tenants/bre/performable/floorplan/BreFloorplanData';
import { TenantPerformableFormProps } from '~/tenants/common/form';
import { TenantPerformableAddOns } from '~/tenants/common/performable';
import { TenantPackageAddOnCheckboxName, TenantPackageIncludes } from '~/tenants/common/package';
import BreFloorplanAddOns from '~/tenants/bre/performable/floorplan/BreFloorplanAddOns';
import { PerformableGroupNested } from '~/components/performable/PerformableGroupForm';
import BrePhotosConfig from '~/tenants/bre/performable/photos/BrePhotosConfig';
import {
  BrePackageBoostInclude,
  BrePackageFloorplanInclude,
  BrePackagePhotosInclude,
  BrePackageWebsiteInclude,
} from '~/tenants/bre/package/common';
import BreBoostConfig from '~/tenants/bre/performable/boost/BreBoostConfig';

export default function BreFloorplanForm(props: TenantPerformableFormProps<BreOrderContext>): ReactElement {
  const { context, persona } = props;
  const { RUSH } = BreFloorplanRate[context.metadata.type];

  return (
    <>
      <TenantPackageIncludes message="The default floorplan is a flat earth-tone image but can be upgraded to 3D below.">
        <BrePackageFloorplanInclude />
      </TenantPackageIncludes>
      <FormGroup>
        <TenantPerformableAddOns persona={persona}>
          <BreFloorplanAddOns context={context} persona={persona} />
          <TenantPackageAddOnCheckboxName
            name="rush"
            title="Rush"
            description="Need the floor plan before noon on the next business day?"
            image="tenant/bre/rush.jpg"
            persona={persona}
            cost={RUSH}
          />
        </TenantPerformableAddOns>
      </FormGroup>
    </>
  );
}
